// NPM Imports
import React from "react";

// Components Imports

const RevvSidePanel = props => (
  <div className="revvsidepanel-container">
    <div
      className={`revvsidepanel-wrapper  placement-${props.placement} ${props.className}`}
      data-test="revvsidepanel"
      id="revvsidepanel">
      {props.children}
    </div>
  </div>
);

export default RevvSidePanel;
